import Vue from 'vue'

/**
 * truncate text
 * @param value value to be truncated
 * @param maxLength optional max length of text (default: 200)
 */
const truncate = (value: string, maxLength: number = 200): string => {
  if (!value) return ''
  if (value.length > maxLength) {
    return value.slice(0, maxLength) + '...'
  } else {
    return value
  }
}
Vue.filter('truncate', truncate)

/**
 * capitlize first character of string
 * @param value value to capitalize
 */
const capitalize = (value: string) => {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1)
}
Vue.filter('capitalize', capitalize)
